// React Imports
import React from 'react';

// I18n
import { Translate, I18n } from 'react-redux-i18n';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';

// Project Components
import Progress from '../../global/Progress';


/**
 * Component for displaying the Banned Domain Error Page.
 *
 * This component displays an error message and provides options to sign in with
 * a different Adobe ID or contact the helpdesk.
 *
 * @component
 * @example
 *
 * return (
 *   <ErrorBannedDomain />
 * )
 */
const ErrorBannedDomain = () => {
  // Signs the user out so they can log in with a different Adobe ID.
  const onSignInClick = () => {
    window.adobeIMS.signOut();
  };

  // Grabs the current locale's helpdesk link and opens it in a new window.
  const onHelpdeskClick = () => {
    const url = I18n.t('global.footer.help_link');
    window.open(url, '_blank');
  };

  // Returns the current signed in user's email to insert into translation string.
  const renderImsEmail = () => window.adobeIMS.getUserProfile().email;

  return (
    <div>
      <Progress step={0} />
      <div className="page-container">
        <Heading>
          <Translate value="workflow.error_page.problem_header" />
        </Heading>
        <p>
          <Translate value="workflow.error_page.banned_domain" email={renderImsEmail()} />
        </p>
        <div className="button-container">
          <Button data-testid="signin-button" variant="cta" onClick={onSignInClick}><Translate value="global.ims.sign_in" /></Button>
          <Button data-testid="helpdesk-button" onClick={onHelpdeskClick}><Translate value="workflow.error_page.contact_helpdesk" /></Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBannedDomain;